const en = {
  loading: 'Loading users...',
  loadFailed: 'Failed to load users',
  updateFailed: 'Failed to update roles',
  title: 'Users',
  description: "Who can sign in to this festival's backoffice, and what each of them can edit.",
  newUser: 'New user',
  email: 'Email',
  roles: 'Roles',
  actions: 'Actions',
  selectRoles: 'Select roles...',
  updating: 'Updating...',
  updateRoles: 'Update roles',
  noRoles: 'No roles',
  noActions: 'No actions',
  /** The button in a user's row, which opens the reset password dialog */
  resetPasswordAction: 'Reset Password',
  emailRequired: 'Email is required',
  emailInvalid: 'Please enter a valid email address',
  rolesRequired: 'At least one role must be selected',
  createFailed: 'Failed to create user',
  creating: 'Creating...',
  createUser: 'Create user',
  deleteTitle: 'Delete user',
  deleteConfirm: (email: string) => `This will delete user ${email}. Are you sure?`,
  deleting: 'Deleting...',
  deleteFailed: 'Failed to delete user',
  resetPassword: 'Reset password',
  resetConfirm: (email: string) => `A new password will be sent to ${email}. Continue?`,
  resetting: 'Resetting...',
  resetFailed: 'Failed to reset password',
};

const fr: typeof en = {
  loading: 'Chargement des utilisateurs...',
  loadFailed: 'Impossible de charger les utilisateurs',
  updateFailed: 'Impossible de mettre à jour les rôles',
  title: 'Utilisateurs',
  description: 'Qui peut se connecter au back-office de ce festival, et ce que chacun peut modifier.',
  newUser: 'Nouvel utilisateur',
  email: 'E-mail',
  roles: 'Rôles',
  actions: 'Actions',
  selectRoles: 'Choisir des rôles...',
  updating: 'Mise à jour...',
  updateRoles: 'Mettre à jour les rôles',
  noRoles: 'Aucun rôle',
  noActions: 'Aucune action',
  resetPasswordAction: 'Réinitialiser le mot de passe',
  emailRequired: "L'adresse e-mail est obligatoire",
  emailInvalid: 'Saisissez une adresse e-mail valide',
  rolesRequired: 'Choisissez au moins un rôle',
  createFailed: "Impossible de créer l'utilisateur",
  creating: 'Création...',
  createUser: "Créer l'utilisateur",
  deleteTitle: "Supprimer l'utilisateur",
  deleteConfirm: email => `L'utilisateur ${email} sera supprimé. Êtes-vous sûr\u00a0?`,
  deleting: 'Suppression...',
  deleteFailed: "Impossible de supprimer l'utilisateur",
  resetPassword: 'Réinitialiser le mot de passe',
  resetConfirm: email => `Un nouveau mot de passe sera envoyé à ${email}. Continuer\u00a0?`,
  resetting: 'Réinitialisation...',
  resetFailed: 'Impossible de réinitialiser le mot de passe',
};

const messages = { en, fr };
export default messages;
